import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.33 10.001a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.667 0",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.472 7.476a.625.625 0 0 1 .884 0l1.641 1.641 1.642-1.641a.625.625 0 0 1 .884.884L10.88 10l1.642 1.642a.625.625 0 0 1-.884.884l-1.642-1.642-1.641 1.642a.625.625 0 1 1-.884-.884L9.114 10 7.472 8.36a.625.625 0 0 1 0-.884"
    }, null, -1)
  ])))
}
export default { render: render }